import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IAppDrawer, IPersonalAccountPartsVisibility } from './types/app-drawer-interface'

const appDrawerState = (state: RootState): IAppDrawer => state.appDrawer

export const AppDrawerSelector = createSelector(
    [appDrawerState],
    (state): IPersonalAccountPartsVisibility => state.AppDrawer,
)
export const AppDraweError = createSelector(
    [appDrawerState],
    (state): string[] => state.errorAppDrawer,
)
export const AppDraweLoading = createSelector(
    [appDrawerState],
    (state): boolean => state.isLoadingAppDrawer,
)